// extracted by mini-css-extract-plugin
export default {"similarSection":"SimilarSection_similarSection__xo4ww"};